module.exports = __webpack_public_path__ + "img/qiu.55e8b1a3.png";